module.exports = __webpack_public_path__ + "static/media/cw_article_details_h.5119c8fe.png";